import apiClient from 'utils/apiClient';
import { useSWRConfig } from 'swr';
import API_BASE_URL from 'config/api';

export default function useUpdate(endpoint) {
  const { mutate } = useSWRConfig();

  const update = async (id, payload, opts = { revalidate: true }) => {
    const url = `${endpoint}/${id}`;
    const res = await apiClient.put(url, payload);
    if (opts.revalidate) await mutate(endpoint);
    return res.data;
  };

  return { update };
}
